// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"802":"3778c7fa","842":"6d55d10d"}[chunkId] + ".chunk.css";
};